/**
 * Convert server pendingVeilcasterWeaponStealFlyAnimations to viewer-relative fly grant payloads.
 */

const VEILCASTER_WEAPON_STEAL_FLY_SOURCE = 'veilcaster_168';

function mapBattlefieldSlotToViewer(playerId, zone, slotIndex, viewerUserId) {
  if (playerId == null || zone == null || slotIndex == null) {
    throw new Error('mapBattlefieldSlotToViewer: playerId, zone, and slotIndex are required');
  }
  const prefix = String(playerId) === String(viewerUserId) ? 'your' : 'opponent';
  return {
    zone: `${prefix}_${zone}`,
    index: slotIndex,
  };
}

function buildVeilcasterWeaponStealFlySnapshot(anim) {
  if (anim.weaponInstanceId == null) {
    throw new Error('buildVeilcasterWeaponStealFlySnapshot: weaponInstanceId is required');
  }
  if (anim.weaponId == null) {
    throw new Error('buildVeilcasterWeaponStealFlySnapshot: weaponId is required');
  }
  return {
    id: anim.weaponId,
    name: anim.weaponName || `Weapon ${anim.weaponId}`,
    instanceId: anim.weaponInstanceId,
    type: 'weapon',
    cost: 0,
    isPlayable: false,
    isOOR: false,
  };
}

function consumePendingVeilcasterWeaponStealFlyAnimations(gameStateFragment, viewerUserId) {
  if (!gameStateFragment?.pendingVeilcasterWeaponStealFlyAnimations?.length) {
    return [];
  }
  if (viewerUserId == null) {
    throw new Error('consumePendingVeilcasterWeaponStealFlyAnimations: viewerUserId is required');
  }

  const pending = [...gameStateFragment.pendingVeilcasterWeaponStealFlyAnimations];
  delete gameStateFragment.pendingVeilcasterWeaponStealFlyAnimations;

  return pending.map((anim) => {
    if (!anim.animationKey) {
      throw new Error('consumePendingVeilcasterWeaponStealFlyAnimations: animationKey is required');
    }
    if (
      anim.targetZone == null
      || anim.targetSlotIndex == null
      || anim.veilcasterZone == null
      || anim.veilcasterSlotIndex == null
    ) {
      throw new Error(
        `consumePendingVeilcasterWeaponStealFlyAnimations: slots required for ${anim.animationKey}`
      );
    }

    const fromSlot = mapBattlefieldSlotToViewer(
      anim.targetPlayerId,
      anim.targetZone,
      anim.targetSlotIndex,
      viewerUserId
    );
    const toSlot = mapBattlefieldSlotToViewer(
      anim.veilcasterPlayerId,
      anim.veilcasterZone,
      anim.veilcasterSlotIndex,
      viewerUserId
    );

    return {
      key: anim.animationKey,
      fromZone: fromSlot.zone,
      fromIndex: fromSlot.index,
      toZone: toSlot.zone,
      toIndex: toSlot.index,
      weaponId: anim.weaponId,
      weaponName: anim.weaponName,
      weaponInstanceId: anim.weaponInstanceId,
      sequenceIndex: anim.sequenceIndex ?? 0,
      source: anim.source || VEILCASTER_WEAPON_STEAL_FLY_SOURCE,
      weaponSnapshot: buildVeilcasterWeaponStealFlySnapshot(anim),
    };
  });
}

module.exports = {
  VEILCASTER_WEAPON_STEAL_FLY_SOURCE,
  consumePendingVeilcasterWeaponStealFlyAnimations,
};
